export default "__VITE_ASSET__40135bf5__"